import { render, staticRenderFns } from "./DocxTmpl.vue?vue&type=template&id=4d3f0bf3&scoped=true"
import script from "./DocxTmpl.vue?vue&type=script&lang=js"
export * from "./DocxTmpl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3f0bf3",
  null
  
)

export default component.exports